var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.041,
    cy: 15.8027,
    r: 14.5027,
    fill: "#EEF0F2",
    stroke: "white",
    strokeWidth: 1.08819
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6022 7.62845C17.1655 7.06426 18.0792 7.06391 18.643 7.62768L21.3379 10.3226C21.8969 10.8816 21.9027 11.7865 21.3509 12.3525L19.5512 14.199L14.7928 9.44057L16.6022 7.62845ZM14.0278 10.2067L18.7955 14.9744L12.7437 21.1837C12.3362 21.6017 11.7775 21.8374 11.194 21.8373L8.26441 21.8372C7.64883 21.8372 7.15722 21.324 7.18311 20.7085L7.30778 17.7445C7.33059 17.2023 7.55595 16.6884 7.93929 16.3045L14.0278 10.2067ZM22.127 22.314C22.4259 22.314 22.6682 22.0715 22.6682 21.7724C22.6682 21.4733 22.4259 21.2308 22.127 21.2308H16.6737C16.3749 21.2308 16.1326 21.4733 16.1326 21.7724C16.1326 22.0715 16.3749 22.314 16.6737 22.314H22.127Z",
    fill: "#BDBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/edit_image.291bcfc25a4a5e646ad7590011550ac5.svg";
export { ForwardRef as ReactComponent };